
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1159:144)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28 26a7 7 0 11-14 0 7 7 0 0114 0zm-1.4 0a5.6 5.6 0 11-11.2 0 5.6 5.6 0 0111.2 0zm-6.93 3.91v-2.093h1.749c.98 0 1.741-.23 2.284-.692.546-.46.819-1.106.819-1.935 0-.81-.279-1.46-.837-1.952-.554-.492-1.303-.738-2.248-.738H18.2v7.41h1.47zm1.766-3.273H19.67v-2.952h1.807c.488.008.872.15 1.15.425.28.27.419.635.419 1.092 0 .465-.137.821-.413 1.069-.275.244-.674.366-1.197.366z","fill":"#06F"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1159:144","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1159:144"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1159:144","result":"shape"}})])])])
          )
        }
      }
    